import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { TransactionsService, TransactionInfo } from './transactions.service';

@Injectable()
export class ResolverJobsTransactionsService implements Resolve<TransactionInfo> {

	constructor(
		private transcService: TransactionsService
	) { }

	async resolve(): Promise<TransactionInfo> {
		// pageSize's affected by jobs-summary component, since this is for use in that component
		const transactionInfo = this.transcService.getTransactions(null, { rowCount: 1, pageSize: 10 });
		return transactionInfo;
	}

}
